const fonts = {
  default: 'bold 16px/22px "Open Sans"',
  placeholder: '14px/22px "Open Sans"',
};

export default fonts;
